import React from "react";
import { Link } from "react-router-dom";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Custom Styles
import "./footer.styles.scss";

// Assets
import BusinessLogo from "../../assets/img/logo.jpg";
import PhoneIconBgGrey from "../../assets/img/phone-icon--grey.svg";
import LocationIconBgGrey from "../../assets/img/location-icon--grey.svg";
import ClockIconBgGrey from "../../assets/img/clock-icon--grey.svg";
import FbIconBgGrey from "../../assets/img/fb-icon--grey.svg";
import IgIconBgGrey from "../../assets/img/ig-icon--grey.svg";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__top">
        <Container fluid>
          <Row>
            <Col xs="12" lg="4">
              <img className="footer__logo" src={BusinessLogo} alt="" />
              <p className="footer__description">
                La Escuela Normal Superior Federal de Aguascalientes “Profr.
                José Santos Valdés” (ENSFA) es una institución pública de
                educación superior fundada en el año de 1977 que tiene como
                función principal la formación inicial de licenciadas y
                licenciados para la Educación Secundaria y Telesecundaria
              </p>
              <p
                style={{
                  color: "#8b131c",
                  marginTop: ".3rem",
                  fontWeight: "bolder",
                  fontSize: "17px",
                }}
              >
                "SCIENTIA ET LIBERTAS"
              </p>
            </Col>
            <Col xs="6" lg="2" className="mt-3 mt-lg-0">
              <ul>
                Nosotros
                <li>
                  <Link to="/acerca-de">Acerca de</Link>
                </li>
                <li>
                  <Link to="/oferta-educativa">Licenciaturas</Link>
                </li>
                <li>
                  <Link to="/maestrias">Posgrado</Link>
                </li>
                <li>
                  <Link to="/acerca-de#mision">Misión</Link>
                </li>
                <li>
                  <Link to="/acerca-de#vision">Visión</Link>
                </li>
              </ul>
            </Col>
            <Col xs="6" lg="2" className="mt-3 mt-lg-0">
              <ul>
                Información
                <li>
                  <Link to="/eventos">Eventos</Link>
                </li>
                <li>
                  <Link to="/aviso-de-privacidad">Aviso de Privacidad</Link>
                </li>
                <li>
                  <Link to="/contacto">Contacto</Link>
                </li>
              </ul>
            </Col>
            <Col xs="12" lg="4">
              <ul>
                Contacto
                <li>
                  <a href="tel:+">
                    <img src={PhoneIconBgGrey} alt="" /> (449)-975-2100
                  </a>
                </li>
                <li>
                  <a href="http://" target="_blank" rel="noopener noreferrer">
                    <img src={LocationIconBgGrey} alt="" srcSet="" />
                    Av. Nazario Ortiz Garza S/N, C.P. 20170 Aguascalientes, Ags.
                  </a>
                </li>
                <li>
                  <img src={ClockIconBgGrey} alt="" srcSet="" /> Lunes -
                  Viernes: 8am - 3pm​{" "}
                </li>
                <li>
                  <div className="d-flex mt-3">
                    <a
                      href="https://www.facebook.com/p/Escuela-Normal-Superior-Federal-de-Aguascalientes-Oficial-100092741296575/?locale=es_LA"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-block me-2"
                    >
                      <img src={FbIconBgGrey} alt="" />
                    </a>
                    <a
                      href="https://www.instagram.com/normal_superior_federal_ags"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-block"
                    >
                      <img src={IgIconBgGrey} alt="" />
                    </a>
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="footer__bottom">
        <Container fluid>
          <div>
            <p>
              &copy; {currentYear} Escuela Normal Superior Federal de
              Aguascalientes. Todos los derechos reservados.
            </p>
          </div>
          <div>
            <p>
              Diseñado y desarrollado por{" "}
              <a
                href="http://quintech.mx"
                target="_blank"
                rel="noopener noreferrer"
              >
                QuinTech
              </a>
            </p>
          </div>
        </Container>
      </div>
    </footer>
  );
}

export default Footer;
